function handles({ domain }) {
  return domain === 'gfycat.com';
}

export default handles;



// WEBPACK FOOTER //
// ./src/components/GfycatPost/handles.js